// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__EBEZK","bigColWidth":"Table_bigColWidth__2OkJ5","biggerColWidth":"Table_biggerColWidth__7HCri","row":"Table_row__3_C7A","col":"Table_col__28KLi"};